import React, {useEffect, useState} from "react";
import {Dialog, DialogContent, Typography} from "@mui/material";
import Login from "../pages/Login";
import ForgotPassword, {Invitation} from "../pages/ForgotPassword";

// Sign-in and password reset, in a dialog over the landing page.
//
// It opens by itself on arrival for a signed-out visitor -- signing in is the only thing this portal
// currently offers, so making someone hunt for the button would be ceremony. It is still dismissible:
// the landing page says what the portal is, and someone who arrived to read that should be able to.
// The nav bar's account button reopens it.

type Screen = "login" | "forgot";

export default function AuthDialog({open, onClose, onSignedIn, invitation, notice}: {
    open: boolean;
    onClose: () => void;
    onSignedIn: () => void;
    invitation?: Invitation;
    /** Why they are being asked to sign in, when it is not the first time -- a session that ended. */
    notice?: string | null;
}) {
    const [screen, setScreen] = useState<Screen>(invitation ? "forgot" : "login");

    // Reopening always lands on sign-in -- unless the visitor arrived on an invitation link, which
    // is a request to set a password and nothing else. Coming back to a half-finished reset flow,
    // with its code already expired, is worse than starting over.
    useEffect(() => {
        if (open) setScreen(invitation ? "forgot" : "login");
    }, [open, invitation]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
                slotProps={{paper: {sx: {borderRadius: "10px"}}}}>
            <DialogContent sx={{px: 4, py: 4}}>
                {notice && screen === "login" && (
                    <Typography sx={{fontSize: 13, color: "#475467", backgroundColor: "#F2F4F7", borderRadius: 1,
                                     px: 1.5, py: 1, mb: 2, lineHeight: 1.5}}>{notice}</Typography>
                )}
                {screen === "forgot"
                    ? <ForgotPassword onBack={() => setScreen("login")} invitation={invitation}/>
                    : <Login onSignedIn={onSignedIn} onForgotPassword={() => setScreen("forgot")}/>}
            </DialogContent>
        </Dialog>
    );
}
